// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { map } from 'rxjs/operators';

// import { ResourceService } from '@teem/generic/resource.service';
// import { Order as OrderApi } from '@teem/constants/api';
// import { Order, OrderSerializer } from '@teem/models/Order';

// @Injectable({
//   providedIn: 'root'
// })
// export class OrderService {

//   constructor() { }
// }


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResourceService } from '@teem/generic/resource.service';
import { order as OrderApi } from '@teem/constants/api';
import { Order, OrderSerializer } from '@teem/models/order';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends ResourceService<Order> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      OrderApi.endPoint,
      new OrderSerializer()
    )
  }

  public stats() {
    return this.httpClient.get(`${OrderApi.stats}`, this.httpOptions);
  }

  public action(params: any) {
    console.log(params)
    return this.httpClient.patch(`${OrderApi.action}`, params);
  }

  public getStatuses(uuid: string) {
    return this.httpClient.get(`${OrderApi.getStatuses(uuid)}`);
  }

  public getOrder(uuid: string) {
    return this.httpClient.get(`${OrderApi.getOrder(uuid)}`);
  }

  public createOtoOrder(params: any) {
    return this.httpClient.post(`${OrderApi.create_oto_order}`, params);
  }

  public initiateRefund(uuid: string,params: any) {
    return this.httpClient.post(`${OrderApi.initiate_refund(uuid)}`, params);
  }
  
  public createShipmentOnOto(uuid: string) {
    return this.httpClient.get(`${OrderApi.createShipmentOnOto(uuid)}`);
  }

  public checkStatusForRefund(uuid: string) {
    return this.httpClient.get(`${OrderApi.checkStatusForRefund(uuid)}`);
  }

  public scheduleOrder() {
    return this.httpClient.get(`${OrderApi.scheduleOrder}`, this.httpOptions);
  }

  // public commonData() {
  //   return this.httpClient.get(`${OrderApi.common}`, this.httpOptions);
  // }

}
